"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function RollbackactionGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#6C757D",
    clipPath: "url(#prefix__rollbackaction-grey-outline__clip0_16657_4177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.83 2.98H9.442v-.838C9.442 1.533 8.909 1 8.299 1H5.14c-.647 0-1.142.533-1.142 1.142v.838H.571A.586.586 0 000 3.55c0 .305.266.572.571.572h.685v8.642c0 .838.686 1.523 1.523 1.523h3.122c-.266-.305-.457-.647-.647-.952-.038-.076-.076-.114-.076-.19H2.779a.41.41 0 01-.38-.381V4.122h8.603v.837h.039c.38.038.723.115 1.104.267V4.084h.685a.586.586 0 00.571-.571c0-.267-.267-.533-.571-.533zm-4.53 0H5.14v-.838H8.3v.838z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.145 5.645c-.38-.114-.762-.229-1.142-.267-.229-.038-.457-.038-.686-.038-2.931 0-5.33 2.399-5.33 5.33 0 .876.229 1.751.61 2.475.228.419.494.8.799 1.142C7.348 15.353 8.756 16 10.317 16c2.932 0 5.33-2.398 5.33-5.33a5.332 5.332 0 00-3.502-5.025zm-1.828 9.213a4.262 4.262 0 01-3.083-1.333c-.267-.266-.457-.57-.648-.913-.304-.61-.495-1.257-.495-1.942a4.176 4.176 0 014.188-4.188c.19 0 .343 0 .533.038.305.038.61.115.876.229a4.197 4.197 0 012.741 3.921c.076 2.284-1.79 4.188-4.112 4.188z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.889 8.804H9.823l.304-.304a.573.573 0 00.152-.419.573.573 0 00-.152-.419.552.552 0 00-.8 0L8.034 8.995c-.038.038-.076.114-.114.19-.038.076-.038.152-.038.19 0 .039 0 .153.038.19a.832.832 0 00.114.191l1.295 1.295a.573.573 0 00.418.152.572.572 0 00.42-.152.572.572 0 00.152-.42.572.572 0 00-.153-.418l-.304-.305h1.066c.647 0 1.142.534 1.142 1.143s-.533 1.142-1.142 1.142H8.909a.586.586 0 00-.571.57c0 .305.266.572.57.572h2.019a2.29 2.29 0 002.284-2.284c0-1.257-1.066-2.247-2.322-2.247z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__rollbackaction-grey-outline__clip0_16657_4177"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

RollbackactionGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
RollbackactionGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = RollbackactionGreyOutline;
exports["default"] = _default;